import * as THREE from 'three';
import { MORPHS } from './animalRules.js';

export function tintMorph(model, morph) {
  if (!morph || !MORPHS[morph]) return;
  const col = new THREE.Color(MORPHS[morph].color);
  model.traverse((o) => {
    if (o.isMesh && o.material) {
      o.material = o.material.clone();
      o.material.vertexColors = false;
      o.material.map = null;
      if (o.material.color) o.material.color.copy(col);
      if (o.material.emissive) o.material.emissive.setHex(0x000000);
      o.material.needsUpdate = true;
    }
  });
}

export function makeHerdBadge(n) {
  const cv = document.createElement('canvas');
  cv.width = 128;
  cv.height = 72;
  const x = cv.getContext('2d');
  x.fillStyle = 'rgba(28,38,48,0.86)';
  x.beginPath();
  x.roundRect(8, 12, 112, 48, 14);
  x.fill();
  x.fillStyle = '#ffe08a';
  x.font = 'bold 40px system-ui';
  x.textAlign = 'center';
  x.textBaseline = 'middle';
  x.fillText('\u00d7' + n, 64, 38);
  const tex = new THREE.CanvasTexture(cv);
  const s = new THREE.Sprite(new THREE.SpriteMaterial({ map: tex, depthTest: false, transparent: true }));
  s.scale.set(1.4, 0.79, 1);
  s.position.y = 3.6;
  return s;
}

export function disposeBadge(b) {
  if (!b || !b.material) return;
  if (b.material.map) b.material.map.dispose();
  b.material.dispose();
}

function makeEmoteTexture(emoji) {
  const c = document.createElement('canvas');
  c.width = c.height = 64;
  const ctx = c.getContext('2d');
  ctx.font = '48px serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(emoji, 32, 36);
  const tex = new THREE.CanvasTexture(c);
  tex.colorSpace = THREE.SRGBColorSpace;
  return tex;
}

let EMOTES = null;
export function getEmotes() {
  if (!EMOTES) {
    EMOTES = {
      happy: new THREE.SpriteMaterial({ map: makeEmoteTexture('\u2764\ufe0f'), transparent: true, depthWrite: false }),
      sad:   new THREE.SpriteMaterial({ map: makeEmoteTexture('\ud83d\ude22'), transparent: true, depthWrite: false }),
      sick:  new THREE.SpriteMaterial({ map: makeEmoteTexture('\ud83e\udd12'), transparent: true, depthWrite: false }),
    };
  }
  return EMOTES;
}
